import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice, shortenNameForCartDropdown } from '../utils';
import { useCart } from '../context/CartContext';  // import useCart
import { FaShoppingCart } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const CartDropdown = () => {
  const { t, i18n } = useTranslation();
  const { cartItems, getTotal } = useCart();  // access cartItems and getTotal

  // Check if cartItems is null or undefined
  const isCartEmpty = !cartItems || cartItems.length === 0;

  const recordUserClick = async (item, type) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/main/user/click`, {
        itemId: item._id,
        type,
        name: item.name,
        arabicName: item.arabicName,
        link: item.link,
        store: item.store,
        lang: i18n.language
      });
    } catch (err) {
      console.error('Failed to record click:', err);
    }
  };

  return (
    <div className="dropdown dropdown-end">
      <label tabIndex={0} className="btn btn-ghost btn-circle">
        <div className="indicator">
          <FaShoppingCart className="text-lg text-gray-800" />
          <span className="badge badge-sm indicator-item bg-[#FF9900] text-white">{isCartEmpty ? 0 : cartItems.length}</span>
        </div>
      </label>

      <div tabIndex={0} className="mt-3 z-[60] card card-compact dropdown-content w-[280px] sm:w-[350px] lg:w-[400px] bg-white shadow-lg border rounded-md">
        <div className="card-body p-4 max-h-[60vh] overflow-y-auto">
          <h2 className="pt-10 font-bold text-lg mb-3">{isCartEmpty ? 'Your cart is empty' : `${cartItems.length} item(s)`}</h2>

          {/* Cart items list */}
          <div className="space-y-3">
            {isCartEmpty ? (
              <p className="text-center text-gray-500">Your cart is empty</p>
            ) : (
              cartItems.map((item, index) => (
                <div key={index} className="flex gap-3 items-center py-2 border-b last:border-none">
                   <Link
                    to={`/product-page/${item._id}`}
                    onClick={() => recordUserClick(item, "cartDropdownProductBox")}
                    className="flex-shrink-0"
                  >
                  <img src={item.image} alt={item.name} className="w-12 h-12 object-cover rounded" />
                  </Link>
                  <div className="flex-1">
                    <p className="text-sm font-semibold truncate">{shortenNameForCartDropdown(item.name)}</p>
                    <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
                  </div>
                  <p className="text-sm text-[#FF9900]">
                    {/* {formatPrice((item.price * item.quantity))} {item.currency || 'SAR'} */}
                    {formatPrice((parseFloat(item.prices?.discounted || item.prices?.original || 0)) * item.quantity)} {item.prices?.currency || 'SAR'}
                  </p>
                </div>
              ))
            )}
          </div>

          <div className="divider my-3"></div>

          {/* Total price */}
          {!isCartEmpty && (
            <div className="flex justify-between font-semibold">
              <span>Estimated Total:</span>
              <span className="text-[#FF9900]">{formatPrice(getTotal())} {cartItems[0]?.currency || 'SAR'}</span>
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-2 mt-4">
            <Link to="/cart" className="btn btn-sm flex-1 btn-outline border-[#FF9900] text-[#FF9900] hover:bg-[#FF9900] hover:text-white">
              View Cart
            </Link>
            {/* <Link to="/checkout" className="btn btn-sm flex-1 bg-[#FF9900] text-white hover:opacity-90">
              Checkout
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartDropdown;